import $ from 'jquery';
import debug from 'debug';

const log = debug('search-result-filter-panel');

const ELEMENT_SELECTOR = '[data-search-filter-panel]';
const ALL_CHECKBOX = '[data-search-filter-panel__choice-all]';
const CHOICE_CHECKBOX = '[data-search-filter-panel__choice]';

function filterPanel(init, element) {
    const categoryCheckbox = element.querySelector(ALL_CHECKBOX);
    const subCategoryCheckboxes = [
        ...element.querySelectorAll(CHOICE_CHECKBOX),
    ];

    init({ categoryCheckbox, subCategoryCheckboxes });
}

function init(instance) {
    // enforce initial checkbox checked states

    // if subCategoryCheckboxes are checked
    // uncheck category (log warning if not already)
    // apply indeterminate

    const { categoryCheckbox, subCategoryCheckboxes } = instance;

    const checkedSubCategoryCheckboxes = subCategoryCheckboxes.filter(
        (checkbox) => {
            return checkbox.checked;
        }
    );

    const isCatChecked = categoryCheckbox.checked;
    const isSubChecked = !!checkedSubCategoryCheckboxes.length;

    if (isCatChecked && isSubChecked) {
        log(
            `Category ${isCatChecked.id} unchecked as sub categories are checked`,
            checkedSubCategoryCheckboxes
        );
    }

    if (isSubChecked) {
        categoryCheckbox.checked = false;
        categoryCheckbox.indeterminate = true;
    }

    categoryCheckbox.addEventListener('change', handleCategoryChange);

    subCategoryCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', handleSubCategoryChange);
    });

    function handleCategoryChange() {
        if (categoryCheckbox.checked) {
            subCategoryCheckboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
            categoryCheckbox.indeterminate = false;
        }
    }

    function handleSubCategoryChange() {
        const checkedSubCategoryCheckboxes = subCategoryCheckboxes.filter(
            (checkbox) => {
                return checkbox.checked;
            }
        );

		if (checkedSubCategoryCheckboxes.length) {
            categoryCheckbox.checked = false;
            categoryCheckbox.indeterminate = true;
        } else if (checkedSubCategoryCheckboxes.length === 0) {
            categoryCheckbox.checked = false;
            categoryCheckbox.indeterminate = false;
        }
    }
}

$(() => {
    [...document.querySelectorAll(ELEMENT_SELECTOR)].forEach(
        filterPanel.bind(null, init)
    );
});



// WEBPACK FOOTER //
// ./project/client/src/site__horticulture/components/search/results-filter/search-results-filter-panel.js